import React from 'react';
import { Helmet } from 'react-helmet';

const ThanksForm = () => {

  return (
    <div className="ltn__contact-message-area mb-120 mb--100">
      <Helmet>
        <title>Contacta a Artectum | Cotiza Acabados para Construcción</title>
        <meta name="description" content="¿Necesitas baldosas, terrazos o mosaicos? Escríbenos por WhatsApp o deja tu consulta aquí. Te asesoramos en tu proyecto." />
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="ltn__form-box contact-form-box box-shadow white-bg">
              <h4 className="title-2">Obtener una cotización</h4>
              <div className="form-submitted-message">
                <h5>Formulario enviado con éxito</h5>
                <p>Gracias por contactarnos. Nos pondremos en contacto con usted pronto.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThanksForm;